module.exports = __webpack_public_path__ + "static/media/alert-grey-blue.e05c2d8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/alert-grey-blue.svg
// module id = 1492
// module chunks = 0